import { render, staticRenderFns } from "./AutocompleteSelect.vue?vue&type=template&id=b4472c88&"
import script from "./AutocompleteSelect.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports